import React from 'react';
import { TitleEditorStoreEffects, TitleEditorStoreProvider, useTitle } from '@warehouse/title/domain';
import { LoaderWrapper } from '../../../src/components/library/LoaderWrapper';
import { ParentRelationshipEditorAdapter } from './ParentRelationshipEditor.adapter';

export function ParentRelationshipEditorLoader({
	childUuid,
	parentUuid,
	relationshipType,
	onClose,
}: ParentRelationshipEditorLoaderProps) {
	const childQueryOutput = useTitle({ uuid: childUuid });
	const parentQueryOutput = useTitle({ uuid: parentUuid });

	if (!childQueryOutput.data || !parentQueryOutput.data) {
		return (
			<div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<LoaderWrapper loading opacity={100} />
			</div>
		);
	}

	return (
		<TitleEditorStoreProvider titleUuid={childUuid}>
			<TitleEditorStoreEffects />
			<ParentRelationshipEditorAdapter
				parentUuid={parentUuid}
				relationshipTypeId={relationshipType}
				childData={childQueryOutput.data}
				parentData={parentQueryOutput.data}
				parentRefetch={parentQueryOutput.refetch}
				onClose={onClose}
			/>
		</TitleEditorStoreProvider>
	);
}

interface ParentRelationshipEditorLoaderProps {
	childUuid: string;
	parentUuid: string;
	relationshipType: string;
	onClose: () => void;
}
